import React from 'react';
import { Link } from 'react-router-dom';
import './Thoughts.css';

function Thoughts() {
  return (
    <div className="App">
      <main className="main-content">
        <div className="content-wrapper">
          <h1>Thoughts</h1>
          
          <p className="description">
            Some of my thoughts and musings.
          </p>

          <div className="thoughts-links">
            <Link to="/excellent-operators" className="thought-link">Why Operators win</Link>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Thoughts;

